import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { mdiInformationOutline } from '@mdi/js';
import BaseTooltip from './BaseTooltip';
import Icon from '../Icon';
import { Padding } from '../Spacing';
import { TooltipIconContainer, TooltipIconInlineContainer } from './styles';
const Tooltip = /*#__PURE__*/forwardRef(({
  children,
  overlay,
  ...props
}, ref) => /*#__PURE__*/React.createElement(BaseTooltip, _extends({
  ref: ref,
  popup: /*#__PURE__*/React.createElement(Padding, {
    all: "sm"
  }, typeof overlay === 'function' ? overlay() : overlay)
}, props), children));
Tooltip.propTypes = {
  overlay: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  children: PropTypes.node.isRequired
};
export const TooltipIconTrigger = /*#__PURE__*/forwardRef(({
  icon = mdiInformationOutline,
  inline = false,
  iconProps = {}
}, ref) => {
  if (inline) {
    return /*#__PURE__*/React.createElement(TooltipIconInlineContainer, {
      ref: ref
    }, /*#__PURE__*/React.createElement(Icon, _extends({
      icon: icon,
      size: "small"
    }, iconProps)));
  }
  return /*#__PURE__*/React.createElement(TooltipIconContainer, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    icon: icon,
    size: "small"
  }, iconProps)));
});
export default Tooltip;
//# sourceMappingURL=index.js.map